module.exports = __webpack_public_path__ + "img/so-so-disabled.8028f83a.svg";